import { render, staticRenderFns } from "./ThgBillingAccountingSelectionView.vue?vue&type=template&id=28fad5b0&"
import script from "./ThgBillingAccountingSelectionView.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingAccountingSelectionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports